<template>
    <!-- 开题报告 -->
    <div class="replyMain">
        <p class="introduce">说明：提交后请等待教师评阅审核，教师完成评阅或审核后即可查看评阅或审核记录</p>
        <el-form ref="form" :model="form" label-width="100px" class="replyform">
            <el-form-item label="论文选题：">
                <!-- <el-input v-model="form.thesisTitle"></el-input> -->
                <span>{{ form.thesisTitle }}</span>
            </el-form-item>
            <el-form-item label="开题报告:">
                <span style="float:left;margin-right:20px;">
                    <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers" :show-file-list="false"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled="disabledset">
                        <span>{{ form.proposalFileName }}</span>
                        <el-button size="small" type="primary" :disabled="disabledset">点击上传</el-button>
                    </el-upload>
                </span>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save" :disabled="disabledset">提交</el-button>
                <span style="color: red;">{{ endMsg }}</span>
            </el-form-item>
        </el-form>
        <el-row>
            <p>开题报告指导记录</p>
            <el-table :data="recordData" border style="width: 100%">
                <el-table-column align="center" prop="uploadFileName" label="文件名称">
                </el-table-column>
                <el-table-column align="center" prop="approveTeacherName" label="指导老师">
                </el-table-column>
                <el-table-column align="center" prop="approveFileName" label="老师指导附件">
                    <template slot-scope="scope">
                        <span @click="getFile(scope.row.approveFileUrl,'开题报告老师审核.docx')" style="color:#1890ff;cursor:pointer">{{
                            scope.row.approveFileName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="approveStatusText" label="审批状态">
                </el-table-column>
                <el-table-column align="center" prop="approveOpinion" label="老师指导意见">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import { getCookieForRoleTag } from '../../../common/ulit'
export default {
    name: "proposal",
    data() {
        return {
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
            thesisRecord: {}, //提交内容
            recordData: [], //审核记录
            state: 0, //0  1  2  3未提交  未审批 驳回修改   完成  
            disabledset: false,
            form: {
                thesisRecordId: '',
                proposalFileUrl: '',
                proposalFileName: '',
                thesisTitle: '',
                thesisDescription: ''
            },
            endMsg: '', //超过截止时间msg
            proposalDead: false, //是否超过截止时间

        }
    },
    mounted() {
        this.recordDataset();
        this.deadlineFunction();
    },
    methods: {
        deadlineFunction() {
            let param = {}
            this.$store.dispatch("thesis/getDeadline", param).then((ret) => {
                if (ret.code == 0) {
                    this.proposalDead = ret.data.proposalDead;
                    if (this.proposalDead == true) {
                        this.disabledset = true
                        this.endMsg = '已超过截止时间，无法提交'
                    }
                } else {
                    this.$message.error(ret.msg);
                }
            })
        },
        recordDataset(thesisRecordId) {
            let param = {
                thesisRecordId: thesisRecordId
            }
            this.$store.dispatch("thesis/getThesisCheckDetailByParam", param).then((ret) => {
                if (ret.code == 0) {
                    this.thesisRecord = ret.data.thesisRecord
                    this.recordData = ret.data.thesisApproveList.filter((item) => {
                        return item.thesisStatus == 2
                    })  //审核记录
                    let thesisStatus = ret.data.thesisRecord.thesisStatus
                    if (thesisStatus > 2) {
                        this.state = 3
                        this.disabledset = true
                    } else if (thesisStatus == 2) {
                        if (this.thesisRecord.isReject == 0) {
                            this.state = 1

                        } else { //驳回
                            this.state = 2
                        }

                    }
                    if (thesisStatus != 2) {
                        this.disabledset = true
                    }

                    /* 内容回显 */
                    this.form.thesisRecordId = this.thesisRecord.id
                    this.form.thesisTitle = this.thesisRecord.choiceThesisTitle
                    this.form.proposalFileName = this.thesisRecord.proposalFileName
                    this.form.proposalFileUrl = this.thesisRecord.proposalFileUrl

                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {

            });
        },
        beforeAvatarUpload(file) {

        },
        handleAvatarSuccess(res, tag) {
            if (res.code == 0) {
                this.form.proposalFileName = res.data.title
                this.form.proposalFileUrl = res.data.url
            }
        },
        save() {
            if (this.state == 2) { //编辑
                let param = {
                    thesisRecordId: this.form.thesisRecordId,
                    proposalFileName: this.form.proposalFileName,
                    proposalFileUrl: this.form.proposalFileUrl,
                }
                this.$store.dispatch("thesis/editProposal", param).then((ret) => {
                    if (ret.code == 0) {
                        this.$message({
                            showClose: true,
                            message: '开题报告修改成功',
                            type: 'success'

                        });
                        this.disabledset = true
                    } else {
                        this.$message.error(ret.msg);
                    }
                }).catch((err) => {
                });
            } else {//新增
                let param = {
                    thesisRecordId: this.form.thesisRecordId,
                    proposalFileName: this.form.proposalFileName,
                    proposalFileUrl: this.form.proposalFileUrl,
                }
                debugger
                this.$store.dispatch("thesis/commitProposal", param).then((ret) => {
                    if (ret.code == 0) {
                        this.$message({
                            showClose: true,
                            message: '开题报告提交成功',
                            type: 'success'

                        });
                        this.disabledset = true
                    } else {
                        this.$message.error(ret.msg);
                    }
                }).catch((err) => {
                });
            }
        },
        //附件下载
        getFile(url, name) {
            const a = document.createElement("a");
            const prefix = window.configs.API_ROOT;
            let setturl=prefix+url
            fetch(setturl)

                .then((res) => res.blob())

                .then((blob) => {

                    // 将链接地址字符内容转变成blob地址

                    a.href = URL.createObjectURL(blob);

                    a.download = name; // 下载文件的名字

                    // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字

                    document.body.appendChild(a);

                    a.click();

                    document.body.removeChild(a);

                })

        }

    }
}
</script>
<style  lang="less">
.replyMain {
    padding: 15px;

    .introduce {
        color: red;
        margin-bottom: 50px;
    }

    .replyform {
        width: 868px;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/transactionPaper/writeGroup/proposal.vue